export default __webpack_public_path__ + "static/media/t6.504146b1.jpg";